import { PanelStack as _PanelStack } from '@blueprintjs/core';
import styled from 'styled-components';

export default styled(_PanelStack)`
  height: 400px;
`;
